var _path, _path2, _rect, _ellipse, _rect2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteGiftsLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4375 29.2188L41.4983 37.9844H31.3767L36.4375 29.2188Z",
    fill: "#E6A500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8438 26.4688L29.3101 30.9817L34.0553 30.9817L30.2164 33.7709L31.6827 38.2839L27.8438 35.4947L24.0048 38.2839L25.4711 33.7709L21.6322 30.9817L26.3774 30.9817L27.8438 26.4688Z",
    fill: "#81B1A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.46875,
    y: 28.5312,
    width: 9.625,
    height: 9.625,
    rx: 1.03125,
    fill: "#10ABB5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.25,
    cy: 35.2344,
    rx: 4.46875,
    ry: 4.64062,
    fill: "#C0D8D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5312,
    y: 20.625,
    width: 12.0312,
    height: 26.8125,
    fill: "#3A5E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 20.7539V42.9902C44.4727 44.1697 44.0041 45.3009 43.1701 46.1349C42.3361 46.969 41.2049 47.4375 40.0254 47.4375H26.6836V20.7539H44.4727ZM7.41211 47.4375C6.23262 47.4375 5.10144 46.969 4.26742 46.1349C3.43339 45.3009 2.96484 44.1697 2.96484 42.9902V20.7539H20.7539V47.4375H7.41211Z",
    fill: "#81B1A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89453 10.5059C8.89453 8.54005 9.67545 6.65475 11.0655 5.26471C12.4555 3.87467 14.3408 3.09375 16.3066 3.09375C18.2725 3.09375 20.1578 3.87467 21.5478 5.26471C22.9378 6.65475 23.7188 8.54005 23.7188 10.5059C23.7188 8.54005 24.4997 6.65475 25.8897 5.26471C27.2797 3.87467 29.165 3.09375 31.1309 3.09375C33.0967 3.09375 34.982 3.87467 36.372 5.26471C37.7621 6.65475 38.543 8.54005 38.543 10.5059V10.5236C38.543 10.7312 38.543 11.3242 38.4303 11.9883H44.4727C45.259 11.9883 46.0131 12.3006 46.5691 12.8567C47.1251 13.4127 47.4375 14.1668 47.4375 14.9531V17.918C47.4375 18.7043 47.1251 19.4584 46.5691 20.0144C46.0131 20.5704 45.259 20.8828 44.4727 20.8828H2.96484C2.17852 20.8828 1.4244 20.5704 0.868383 20.0144C0.312367 19.4584 0 18.7043 0 17.918V14.9531C0 14.1668 0.312367 13.4127 0.868383 12.8567C1.4244 12.3006 2.17852 11.9883 2.96484 11.9883H9.0072C8.92889 11.5041 8.8912 11.0141 8.89453 10.5236V10.5059ZM12.061 11.9883H20.7539V10.5059C20.7539 9.92184 20.6389 9.34353 20.4154 8.80396C20.1919 8.2644 19.8643 7.77413 19.4513 7.36117C19.0384 6.9482 18.5481 6.62062 18.0085 6.39712C17.469 6.17363 16.8907 6.05859 16.3066 6.05859C15.7226 6.05859 15.1443 6.17363 14.6047 6.39712C14.0652 6.62062 13.5749 6.9482 13.1619 7.36117C12.749 7.77413 12.4214 8.2644 12.1979 8.80396C11.9744 9.34353 11.8594 9.92184 11.8594 10.5059C11.8594 10.7579 11.8653 11.3182 11.9928 11.7807C12.0106 11.8514 12.0334 11.9208 12.061 11.9883ZM26.6836 11.9883H35.3765C35.4038 11.9207 35.4266 11.8513 35.4447 11.7807C35.5722 11.3182 35.5781 10.7579 35.5781 10.5059C35.5781 9.32637 35.1096 8.19519 34.2756 7.36117C33.4415 6.52714 32.3103 6.05859 31.1309 6.05859C29.9514 6.05859 28.8202 6.52714 27.9862 7.36117C27.1521 8.19519 26.6836 9.32637 26.6836 10.5059V11.9883Z",
    fill: "url(#paint0_linear_6_1096)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1096",
    x1: 9.74633,
    y1: 3.09375,
    x2: 19.5869,
    y2: 32.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGiftsLink);
export default __webpack_public_path__ + "static/media/inviteGiftsLink.a233e4620a937f55726970a88942846b.svg";
export { ForwardRef as ReactComponent };